import { doodBlockConfig, propertyValue } from './dood-block-config';
import { cartPagePresetBlockBackgroundColorProperty } from './cart-page-preset-block-background.util';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const CARTONSITELOCATIONBLOCK_LEGACY_FIELD_ORDER = [];

const {
  cartOnSiteLocationBlockDescriptor: _generatedCartOnSiteLocationBlockDescriptor,
  cartOnSiteLocationBlockBlocDefinition,
  cartOnSiteLocationBlockDashboardLayout,
  cartOnSiteLocationBlockConfig,
  cartOnSiteLocationBlockResolveConfig,
  cartOnSiteLocationBlockProperties,
} = doodBlockConfig(
  {
    name: "Cart - On site location",
    componentType: 'CartOnSiteLocationBlockComponent',
    category: 'cart',
    description: "Cart - On site location.",
    keywords: [],
    allowedIn: [
      { bloc: 'CartPageComponent', slot: '*' },
    ],


    sharedFields: {}
  },

  () => ({
    background_color: cartPagePresetBlockBackgroundColorProperty(),
  }),

  () => ({
    tabs: [
      {
        label: 'pages.blocks.cart-page.tab.content.label',
        fieldsets: [
          {
            legend: 'pages.blocks.cart-page.fieldset.appearance.label',
            fields: ['background_color'],
          },
        ],
      },
    ],
  })
);

export function cartOnSiteLocationBlockDescriptor(): IBlockDescriptor;
export function cartOnSiteLocationBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function cartOnSiteLocationBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedCartOnSiteLocationBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedCartOnSiteLocationBlockDescriptor, cartOnSiteLocationBlockProperties, fieldOrder);
}

export {
  cartOnSiteLocationBlockBlocDefinition,
  cartOnSiteLocationBlockDashboardLayout,
  cartOnSiteLocationBlockProperties,
  cartOnSiteLocationBlockConfig,
  cartOnSiteLocationBlockResolveConfig,
};

export type CartOnSiteLocationBlockConfig = typeof cartOnSiteLocationBlockConfig;
